export default "/images/TIGlogo.png?7f046711597dcd68debfb5dac89b5483";